<template>
  <div class="container">
    <app-menu></app-menu>
    <slot></slot>
  </div>
</template>
<script>



import AppMenu from './common/Menu.vue'
import moment from "moment/moment";

export default {
  data() {
    return {

    }
  },
  components: {
    AppMenu
  },
  mounted() {
      this.loadRemoteScript();
      this.$el.addEventListener('change', this.controlerDateMax);
  },
  beforeDestroy() {
      this.$el.removeEventListener('change', this.controlerDateMax);
  },
  methods: {
      controlerDateMax(event) {
          const input = event.target;
          if (!input.matches || !input.matches('input[type="date"][max]')) return;

          let maxDate = new Date(input.getAttribute('max'));
          let selectedDate = new Date(input.value);


          if (selectedDate > maxDate) {
              input.setCustomValidity("La date ne peut pas être dans le futur.");
              input.value = moment(maxDate).format('YYYY-MM-DD');

              // Déclenche un événement 'input' pour mettre à jour l'affichage visuel
              const inputEvent = new Event('input', { bubbles: true });
              input.dispatchEvent(inputEvent);
          } else {
              input.setCustomValidity("");
          }

          input.reportValidity();
      },
      async loadRemoteScript() {
          return;
          /*
          try {
              User.getUserData(function (user) {
                  const script = document.createElement('script');
                  script.setAttribute('data-consolejs-channel', 'mobiledev-31599430-5abe-fi360-4d74-df1f-061994b2b42b-' + user.id);
                  script.src = 'https://remotejs.com/agent/agent.js';
                  script.async = true;
                  document.body.appendChild(script);
                  console.log('remoteJS charged - user : (' + user.id + ') ' + user.last_name + ' ' + user.first_name + ' Operateur : (' + user.operator.id + ') ' + user.operator.company);
                  localStorage.setItem('remotejs', 'mobiledev-31599430-5abe-fi360-4d74-df1f-061994b2b42b-' + user.id);
              })
          } catch (error) {
              console.error('Erreur lors du chargement du script distant :', error);
          }
           */
      },
  }
}

</script>

<style scoped>

.container {
  background-color: #fbfafa;
  font-size: 1.6rem;
  line-height: 1.4;
  font-family: "Open Sans";
  color: #333;

  margin: 0 auto;
  padding: 0;
  width: 100%;
  max-width: 600px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// Layout.vue?00a83e7a